const slideActiveDefaultState = {
  slideActive: {},
  startPresentingFromSlideId: null,
}

export default slideActiveDefaultState
